module.exports = __webpack_public_path__ + "img/animate-2.791880e9.png";